<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead style="background: #425058;">
          <tr>
            <th style="color: #fff;">Country</th>
            <th style="color: #fff;">Code</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="country in getCountries" :key="country.value" @click="copyCountryCode(country.value)">
            <td>{{ country.text }}</td>
            <td>{{ country.value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    countries: Array,
    setCountries: Function
  },
  computed: {
    getCountries () {
      return this.countries
    }
  },
  methods: {
    copyCountryCode (countryCode) {
      this.setCountries(countryCode)
    }
  }
}
</script>
